import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      id: this.$options.name,
      transfer: {},
      user: this.$store.state.user,
      company: this.$store.state.company,
      gettingFiles: false,
      isLoading: true,
      isDownloading: false,
    };
  },
  created() {
    this.transfer.filescount = 0;

    EventBus.$on(`${this.id}--download-files`, () => {
      this.isDownloading = true;

      const link = document.createElement("a");
      link.href = `${baseUrl}/transferdownload?transfer=${this.transfer.id}`;
      link.setAttribute("download", "download");
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  },
  beforeMount() {
    this.$axios
      .get(baseUrl + "/transfer?id=" + this.$route.params.transfer, {
        responseType: "json",
      })
      .then((response) => {
        this.isLoading = false;
        this.transfer = response.data;
      })
      .catch((error) => {
        this.$router.push("/404");
      });
  },
};
